'use es6';

import Raven from 'raven-js';
import curry from 'transmute/curry';

// wrapper function is necessary to provide the correct `this` to
// `captureException`
const reportException = (...args) => {
  Raven.captureException(...args);
};
export const fingerprintedReporter = curry((fingerprint, error) => {
  reportException(error, {
    fingerprint
  });
});